import useToggleState from 'Utils/hooks/useToggleState'

import { useAppDetailContext } from '../../AppDetailContext'
import InstallApp from '../../../components/InstallApp'
import SimpplrAuthForm from './SimpplrAuthForm'

const InstallSimpplr = ({ app }) => {
  const { title } = useAppDetailContext()
  const [showCredentialsForm, toggleCrdentialsForm] = useToggleState(false)

  if (showCredentialsForm) {
    return <SimpplrAuthForm onCancel={toggleCrdentialsForm} app={app} />
  }

  return <InstallApp name={title} onInstall={toggleCrdentialsForm} />
}

export default InstallSimpplr
